<div class="d-flex flex-column flex-root">
  <div class="d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed">
    <div class="d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20">
      <div class="w-lg-800px bg-body rounded shadow-sm p-10 p-lg-15 mx-auto">
        <div class="text-center mb-10">
          <h1 class="text-dark mb-3">Contact Us</h1>
          <p class="text-gray-400 fw-semibold fs-4">Have questions or need assistance? We're here to help!</p>
        </div>

        <div class="card shadow-sm mb-10">
          <div class="card-body p-10">
            <h4 class="text-dark mb-3">Technical Support</h4>
            <p class="mb-3">For any technical issues, questions about the platform, or general inquiries, please email us at:</p>
            <a href="mailto:support@kialearn.com" class="text-primary fs-2 fw-bold d-block mb-5">support@kialearn.com</a>
            
            <div class="text-start">
              <h5 class="text-dark mb-3">To help us assist you better, please include:</h5>
              <ul class="mb-3">
                <li>Description of the issue or question</li>
                <li>Steps to reproduce (if applicable)</li>
                <li>Expected vs actual behavior</li>
                <li>Any error messages received</li>
                <li>Browser/device information</li>
                <li>Screenshots of the issue (if applicable)</li>
              </ul>
              <p class="mb-0">Our support team will process requests based on arrival time and urgency.</p>
            </div>
          </div>
        </div>

        <div class="text-center" *ngIf="!isAuthenticated()">
          <button type="button" class="btn btn-lg btn-light-primary w-100" (click)="goBack()">
            <span class="indicator-label">Back to Login</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div> 